import React from "react";
import {Container} from "reactstrap";
// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import Welcome from "./Components/Welcome";
import NewWayToLearnEnglish from "./Components/NewWayToLearnEnglish";

const AboutUs = () => {
  return (
    <React.Fragment>
      <section
        className="section "
        id="AboutUs"
      >
        <Container>
          <Welcome/>
          <NewWayToLearnEnglish/>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default AboutUs;
